class Shipping {
  shipping_estimates = [];

  constructor(article, market_area = [], mess) {
    this.article = article;
    this.market_area = market_area;
    this.mess = mess;
  }

  getEstimate() {
    // Если deliveryTimeRequest приходит со значеним true,
    // то возвращаем строку "По запросу"
    if (this.article.deliveryTimeRequest) {
      return this.mess.delivery_on_request;
    }

    // Находим первый элемент у которого count больше
    // чем текущее кол-во выбранных товаров
    const availableToDelivery = this.shipping_estimates.find(
      item => parseInt(item.count) >= parseInt(this.article.qty)
    );

    // Если был найден элемент с кол-вом товара на складе больше
    // чем выбранно у пользователя, то возвращаем его время доставки
    if (availableToDelivery) {
      const weekText =
        availableToDelivery.week > 1
          ? this.mess.basket_weeks
          : this.mess.basket_week;

      return `${availableToDelivery.week} ${weekText}`;
    }

    // Если попали сюда, то значит не было найдено элемента с кол-вом
    // товара меньше или равно тому, что выбрано у пользователя.
    // Считаем общее кол-во товаров на всех складах.
    const totalCounts = this.shipping_estimates.reduce((sum, item) => {
      sum += parseInt(item.count);
      return sum;
    }, 0);

    // Если общее кол-во товара меньше выбранного кол-ва товара у пользователя,
    // то возвращаем дефолтный срок доставки (27 нед, передаем при инициализации класса).
    if (totalCounts < this.article.qty) {
      return `${this.article.deliverytime} ${this.mess.basket_weeks}`;
    }

    // На каждой итерации прибавляем к total текущий count
    // если итоговая сумма будет больше чем выбранное кол-во товара
    // то записываем срок доставки текущего объекта и устанавливаем skip = true чтобы больше не выполнять сложение и проверку,
    // так как мы уже нашли нужный срок доставки.
    const weeks = this.shipping_estimates.reduce(
      (prev, item) => {
        if (prev.skip) {
          return prev;
        }

        prev.total += parseInt(item.count);

        if (prev.total >= this.article.qty) {
          prev.weeks = item.week;
          prev.skip = true;

          return prev;
        }

        return prev;
      },
      {
        total: 0,
        skip: false,
        weeks: 0
      }
    ).weeks;
    const weekText = weeks > 1 ? this.mess.basket_weeks : this.mess.basket_week;

    return `${weeks} ${weekText}`;
  }

  getNewEstimate(totalCounts) {
    const difference = this.article.qty - totalCounts;
    const text = this.mess.count_after_number_week
      .replace("#count#", difference)
      .replace("#number#", this.article.deliverytime);

    return {
      count: difference,
      week: this.article.deliverytime,
      text
    };
  }

  getShippingEstimates() {
    return this.shipping_estimates.map(item => {
      item.text =
        item.week > 1
          ? `${item.count} / ${item.week} ${this.mess.basket_weeks}`
          : `${item.count} / ${item.week} ${this.mess.basket_week}`;

      return item;
    });
  }

  mergingEstimates() {
    this.shipping_estimates = this.shipping_estimates.reduce((arr, item) => {
      const equal_shipping = arr.find(
        element => parseInt(element.week) === parseInt(item.week)
      );

      if (equal_shipping) {
        equal_shipping.count += parseInt(item.count);
        equal_shipping.text =
          equal_shipping.count > 1
            ? `${equal_shipping.count} / ${equal_shipping.week} ${this.mess.basket_weeks}`
            : `${equal_shipping.count} / ${equal_shipping.week} ${this.mess.basket_week}`;

        return arr;
      }

      return [...arr, ...[item]];
    }, []);
  }

  filteringByMarketArea() {
    const { shippingEstimate } = this.article;

    if (!this.market_area.length) {
      this.shipping_estimates = shippingEstimate;
      return;
    }

    const mapped_market_area = this.market_area.map(item =>
      item.length ? item.toLowerCase() : item
    );

    if (!shippingEstimate.length) return [];

    this.shipping_estimates = shippingEstimate.filter(item => {
      if (!item.hasOwnProperty("market_area")) {
        return false;
      }

      return mapped_market_area.includes(item.market_area.toLowerCase());
    });
  }
}

export default Shipping;
